var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusinessRolesSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.85,
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.333,
    height: 10.667,
    x: 0.333,
    y: 2.668,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.667 2.667V1.333C5.668.598 6.264.002 7 0h2c.735.002 1.331.598 1.333 1.333v1.334M8 6.001L8 5.335M9 6H7.645c-.429 0-.797.304-.878.725-.081.42.147.84.544 1l1.376.55c.399.159.628.579.546 1-.08.421-.45.725-.879.725H7M8 10.668L8 10.001"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessRolesSmall);
export default __webpack_public_path__ + "static/media/business-roles-small.a074c573.svg";
export { ForwardRef as ReactComponent };